/*
 * Developed by CQ Inversiones SAS. Copyright ©. 2023 - 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS. Copyright ©. 2023 - 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         10/07/23 - 6:48 AM
 * Module name:  main-menu.constants
 * File name:    main-menu.constants.ts
 * IDE:          WebStorm
 */

import {NbMenuItem} from '@nebular/theme';
import {MenuComponentConfigEnum} from '../../enums';
import {UserLevelEnum} from '@zibanu/auth';
import {CustomerLevelEnum} from '@shared/interface/settings/customer/customers/customers.interface';

export const MENU_ITEM_OVERVIEW = 10;
export const MENU_ITEM_PARTNERS_TITLE = 30;
export const MENU_ITEM_PARTNERS = 35;
export const MENU_ITEM_USERS = 40;
export const MENU_ITEM_CONTRACTS = 45;
export const MENU_ITEM_CUSTOMERS_ADMIN = 50;
export const MAIN_MENU_ITEM_HOME = 5;
export const MAIN_MENU_ITEM_REPORT_DETAIL = 15;
export const MAIN_MENU_ITEM_REPORTS = 20;
export const MAIN_MENU_ITEM_SETTING = 25;
export const PUBLIC_MENU_ITEM_ABOUT_TITLE = 55;
export const PUBLIC_MENU_ITEM_ABOUT = 60;
export const MAIN_MENU_ITEM_LOGOUT_TITLE = 65;
export const MAIN_MENU_ITEM_LOGOUT = 70;


export interface MkadMenuItem extends NbMenuItem {
  children?: MkadMenuItem[];
  data: {
    guest?: boolean,
    component?: MenuComponentConfigEnum,
    id?: number,
    level: UserLevelEnum,
    clientLevel: CustomerLevelEnum | null,
  };
}


export const PUBLIC_MENU_ITEMS_CONST: MkadMenuItem[] = [
  {
    title: 'app.main.menu.mkad.title',
    group: true,
    data: {
      id: PUBLIC_MENU_ITEM_ABOUT_TITLE,
      level: UserLevelEnum.Guest,
      clientLevel: null,
      guest: true,
    },
  },
  {
    title: 'app.main.menu.about.title',
    icon: {
      icon: 'circle-exclamation',
      pack: 'far',
    },
    data: {
      component: MenuComponentConfigEnum.MkadAboutUsComponent,
      id: PUBLIC_MENU_ITEM_ABOUT,
      level: UserLevelEnum.Guest,
      clientLevel: null,
      guest: true,
    },
  }
];

export const SESSION_MENU_ITEMS_CONST: MkadMenuItem[] = [
  ...PUBLIC_MENU_ITEMS_CONST,
  {
    title: 'app.main.menu.session.title',
    group: true,
    data: {
      id: MAIN_MENU_ITEM_LOGOUT_TITLE,
      level: UserLevelEnum.Operator,
      clientLevel: null,
      guest: false,
    },
  },
  {
    title: 'app.main.menu.logout.title',
    icon: {
      icon: 'right-from-bracket',
      pack: 'far',
    },
    data: {
      component: MenuComponentConfigEnum.MkadLogoutComponent,
      id: MAIN_MENU_ITEM_LOGOUT,
      guest: false,
      level: UserLevelEnum.Operator,
      clientLevel: null,
    },
  },
];

export const ALL_MENU_ITEMS_CONST: MkadMenuItem[] = [
  {
    title: 'app.main.menu.home.title',
    home: true,
    link: '/home',
    icon: {
      icon: 'house',
      pack: 'far',
    },
    data: {
      id: MAIN_MENU_ITEM_HOME,
      level: UserLevelEnum.Guest,
      clientLevel: CustomerLevelEnum.final,
      guest: true,
    },
  },
  {
    title: 'app.main.menu.overview.title',
    link: '/overview',
    icon: {
      icon: 'house-circle-check',
      pack: 'far',
    },
    data: {
      id: MENU_ITEM_OVERVIEW,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
      guest: false,
    },
  },
  {
    title: 'app.main.menu.reportDetail.title',
    icon: {
      icon: 'file-chart-column',
      pack: 'far',
    },
    data: {
      id: MAIN_MENU_ITEM_REPORT_DETAIL,
      level: UserLevelEnum.Admin,
      clientLevel: CustomerLevelEnum.final,
      guest: false,
    },
  },
  {
    title: 'app.main.menu.reports.title',
    icon: {
      icon: 'file-chart-column',
      pack: 'far',
    },
    data: {
      id: MAIN_MENU_ITEM_REPORTS,
      level: UserLevelEnum.Supervisor,
      clientLevel: CustomerLevelEnum.final,
      guest: false,
    },
  },
  {
    title: 'app.main.menu.settings.title',
    link: '/settings/panel',
    icon: {
      icon: 'gear',
      pack: 'far',
    },
    data: {
      id: MAIN_MENU_ITEM_SETTING,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.final,
      guest: false,
    },
  },
  {
    title: 'app.main.menu.company.title',
    group: true,
    data: {
      id: MENU_ITEM_PARTNERS_TITLE,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
    },
  },
  {
    title: 'app.main.menu.partner.title',
    link: '/settings/customers',
    icon: {
      icon: 'users',
      pack: 'far',
    },
    data: {
      id: MENU_ITEM_PARTNERS,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
    },
  },
  {
    title: 'app.setting.panel.admin.customer.option.user.title',
    link: '/settings/users',
    icon: {
      icon: 'user',
      pack: 'far',
    },
    data: {
      id: MENU_ITEM_USERS,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
    },
  },
  {
    title: 'app.setting.panel.admin.customer.option.contract.title',
    link: '/settings/contracts',
    icon: {
      icon: 'file-contract',
      pack: 'far',
    },
    data: {
      id: MENU_ITEM_CONTRACTS,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
    },
  },
  {
    title: 'app.main.menu.settings.title',
    link: '/settings/administration',
    icon: {
      icon: 'gears',
      pack: 'far',
    },
    data: {
      id: MENU_ITEM_CUSTOMERS_ADMIN,
      level: UserLevelEnum.Operator,
      clientLevel: CustomerLevelEnum.silver,
      guest: false,
    },
  },
  ...SESSION_MENU_ITEMS_CONST
];

export const MENU_MAIN_CONST: MkadMenuItem[] = [...ALL_MENU_ITEMS_CONST];
